const parseJwt = token => {
  let base64Url = token.split(".")[1];
  let base64 = base64Url.replace("-", "+").replace("_", "/");

  return JSON.parse(atob(base64));
};

export default { parseJwt };
